/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_TitleInputs */

const en_fc_tut_title = /** @type {(inputs: Fc_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit your first video in FilmCraft.`)
};

/**
* | output |
* | --- |
* | "Edit your first video in FilmCraft." |
*
* @param {Fc_Tut_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_title = /** @type {((inputs?: Fc_Tut_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_title(inputs)
});
export { fc_tut_title as "fc.tut.title" }